module.exports = __webpack_public_path__ + "media/images/team/tim-5e2a3d61d4d1a95e5ae2bf89b532b998.jpg";